import axios from "axios";

export const getDataTableTransaksiKeluar = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/transaksiKeluar/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/transaksiKeluar/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDataTransKeluar = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/transaksiKeluar/transKeluar?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/transaksiKeluar/transKeluar?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getFilteredTransaksiKeluar = async (condition) => {
  return await axios.post(
    `${window._HOST}admin/transaksiKeluar/filteredData`,
    condition,
    { withCredentials: true }
  );
};

export const insertNewTransaksiKeluar = async (formData) => {
  return await axios.post(`${window._HOST}admin/transaksiKeluar/`, formData, {
    withCredentials: true,
  });
};

export const deleteTransaksiKeluar = async (id_transaksi_keluar) => {
  return await axios.delete(
    `${window._HOST}admin/transaksiKeluar/${id_transaksi_keluar}`,
    { withCredentials: true }
  );
};

export const updateTransaksiKeluar = async (id_transaksi_keluar, formData) => {
  return await axios.post(
    `${window._HOST}admin/transaksiKeluar/${id_transaksi_keluar}`,
    formData,
    { withCredentials: true }
  );
};

export const getNomorTransaksiKeluar = async () => {
  return await axios.get(`${window._HOST}admin/transaksiKeluar/noTransKeluar`, {
    withCredentials: true,
  });
};

export const importCSVTransaksiKeluar = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/transaksiKeluar/importCSV/`,
    formData,
    { withCredentials: true }
  );
};

export const exportSpesifikTransaksiKeluar = async () => {
  return await axios.get(`${window._HOST}/admin/transaksiKeluar/specificData`, {
    withCredentials: true,
  });
};
